import { createRoot, type Root } from "react-dom/client";
import KingExplorers from "../pages/KingExplorers/KingExplorers";
import "../index.css";
import "../pages/KingExplorers/KingExplorers.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<KingExplorers />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADKingExplorers = { mount, unmount };

function boot() {
  const element = document.getElementById("king-explorers-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
